










import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import echarts from 'echarts';
import guangxi from '@/data/guangxi.json';

@Component({})
export default class Pseudo3DMap extends Vue {
  @Prop({ type: Object, default: () => ({}) })
  cityDic!: Record<string, number>;

  private myChart: any = null;

  @Watch('cityDic', { deep: true })
  onCityDicChange() {
    if (this.myChart) {
      this.init();
    }
  }

  init() {
    echarts.registerMap('广西', guangxi as any);

    const el = this.$refs.mapRef as any;
    if (this.myChart) {
      this.myChart.dispose();
    }
    this.myChart = echarts.init(el);

    // 基础城市数据模板
    const baseMapData = [
      {
        name: '全省',
        coordinate: [108.320004, 22.82402],
      },
      {
        name: '南宁市',
        coordinate: [108.320004, 22.82402],
      },
      {
        name: '柳州市',
        coordinate: [109.411703, 24.314617],
      },
      {
        name: '桂林市',
        coordinate: [110.299121, 25.274215],
      },
      {
        name: '梧州市',
        coordinate: [111.297604, 23.474803],
      },
      {
        name: '北海市',
        coordinate: [109.119254, 21.473343],
      },
      {
        name: '防城港市',
        coordinate: [108.345478, 21.614631],
      },
      {
        name: '钦州市',
        coordinate: [108.624175, 21.967127],
      },
      {
        name: '贵港市',
        coordinate: [109.602146, 23.0936],
      },
      {
        name: '玉林市',
        coordinate: [110.154393, 22.63136],
      },
      {
        name: '百色市',
        coordinate: [106.616285, 23.897742],
      },
      {
        name: '贺州市',
        coordinate: [111.552056, 24.414141],
      },
      {
        name: '河池市',
        coordinate: [108.062105, 24.695899],
      },
      {
        name: '来宾市',
        coordinate: [109.229772, 23.733766],
      },
      {
        name: '崇左市',
        coordinate: [107.353926, 22.404108],
      },
    ];

    // 根据传入的 cityDic 数据生成 mapData
    const mapData = baseMapData.map(item => {
      const cityName = item.name.replace('市', ''); // 去掉"市"字符以匹配cityDic的key
      const cityValue = this.cityDic[cityName] !== undefined ? this.cityDic[cityName] : 0;

      return {
        ...item,
        tradeBidsectionCount: cityValue,
        tradeProjectCount: cityValue * 2, // 可以根据实际需求调整这个计算逻辑
        value: cityValue,
        originalValue: cityValue, // 保存原始值
      };
    });

    // 广西各城市坐标数据
    const center: any = {
      南宁市: [108.320004, 22.82402],
      桂林市: [110.299121, 25.274215],
      百色市: [106.616285, 23.897742],
      贺州市: [111.552056, 24.414141],
      河池市: [108.062105, 24.695899],
      来宾市: [109.319772, 23.633766],
      崇左市: [107.353926, 22.404108],
      玉林市: [110.154393, 22.63136],
      钦州市: [108.824175, 22.067127],
      防城港市: [107.945478, 21.814631],
      柳州市: [109.411703, 24.314617],
      梧州市: [111.297604, 23.474803],
      北海市: [109.319254, 21.613343],
      贵港市: [109.602146, 23.0936],
    };

    // 根据value值分类数据，设置红、橙、蓝三种颜色等级
    const getWaveColor = (value: number) => {
      if (value >= 50) {
        // 红色 - 高等级
        return {
          borderColor: 'rgba(255, 77, 77, 1)',
          color: 'rgba(255, 77, 77, 0.8)',
          shadowColor: 'rgba(255, 77, 77, 0.6)',
        };
      } else if (value >= 10) {
        // 橙色 - 中等级
        return {
          borderColor: 'rgba(255, 165, 0, 1)',
          color: 'rgba(255, 165, 0, 0.8)',
          shadowColor: 'rgba(255, 165, 0, 0.6)',
        };
      } else if (value > 0) {
        // 蓝色 - 低等级（但大于0）
        return {
          borderColor: 'rgba(64, 158, 255, 1)',
          color: 'rgba(64, 158, 255, 0.8)',
          shadowColor: 'rgba(64, 158, 255, 0.6)',
        };
      } else {
        // 数值为0或负数时不应该调用此函数，但提供默认值
        return {
          borderColor: 'rgba(128, 128, 128, 1)',
          color: 'rgba(128, 128, 128, 0.8)',
          shadowColor: 'rgba(128, 128, 128, 0.6)',
        };
      }
    };

    // 创建水波纹数据 - 过滤掉数值为0的数据
    const waveData = mapData
      .filter(item => item.value > 0) // 只显示数值大于0的水波纹
      .map(item => ({
        name: item.name,
        value: [center[item.name]?.[0] || item.coordinate[0], center[item.name]?.[1] || item.coordinate[1], item.value],
        originalValue: item.value, // 保存原始值用于显示
        itemStyle: {
          normal: getWaveColor(item.value),
        },
      }));

    const option: any = {
      tooltip: {
        trigger: 'item',
        position: function(point: any[], params: any, dom: any, rect: any, size: { contentSize: any[] }) {
          let x = 0; // x坐标位置
          let y = 0; // y坐标位置
          // 当前鼠标位置
          let pointX = point[0];
          let pointY = point[1];
          // 提示框大小
          let boxWidth = size.contentSize[0];
          let boxHeight = size.contentSize[1];

          // boxWidth > pointX 说明鼠标左边放不下提示框
          if (boxWidth > pointX) {
            x = pointX + 15;
          } else {
            // 左边放的下
            x = pointX - boxWidth - 15;
          }

          // boxHeight > pointY 说明鼠标上边放不下提示框
          if (boxHeight > pointY) {
            y = 10;
          } else {
            // 上边放得下
            y = pointY - boxHeight - 10;
          }
          return [x, y];
        },
        show: true,
        enterable: true,
        confine: true, // 限制在容器内
        transitionDuration: 0.3,
        textStyle: {
          fontSize: 14,
          color: '#ffffff',
          fontWeight: '400',
        },
        backgroundColor: 'transparent',
        borderWidth: 0,
        padding: 0,
        extraCssText: 'box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3); backdrop-filter: blur(10px);',
        formatter: function(params: {
          name: any;
          data: { tradeBidsectionCount: any; tradeProjectCount: any; originalValue?: any };
        }) {
          // 确保显示原始值，包括0值
          const displayValue =
            params.data.originalValue !== undefined ? params.data.originalValue : params.data.tradeBidsectionCount;
          const tipHtml = `
            <div style="
              background: rgba(8, 13, 33, 0.9);
              border: 1px solid rgba(60, 149, 206, 1);
              border-radius: 12px;
              padding: 8px 16px;
              min-width: 180px;
              position: relative;
              overflow: hidden;
              backdrop-filter: blur(10px);
            ">
              <!-- 装饰性背景 -->
              <div style="
                position: absolute;
                top: -50%;
                right: -50%;
                width: 100px;
                height: 100px;
                background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);
                border-radius: 50%;
              "></div>

              <!-- 标题区域 -->
              <div style="
                font-size: 16px;
                font-weight: 600;
                color: #ffffff;
                margin-bottom: 12px;
                display: flex;
                align-items: center;
                position: relative;
                z-index: 1;
              ">
                <div style="
                  width: 4px;
                  height: 16px;
                  background: linear-gradient(180deg, #00feff 0%, #3a95fd 100%);
                  border-radius: 2px;
                  margin-right: 8px;
                "></div>
                ${params.name}
              </div>

              <!-- 数据区域 -->
              <div style="position: relative; z-index: 1;">
                <div style="
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  margin-bottom: 8px;
                  padding: 2px 8px;
                  background: rgba(255, 255, 255, 0.1);
                  border-radius: 8px;
                  border: 1px solid rgba(255, 255, 255, 0.1);
                ">
                  <span style="
                    color: #e6f7ff;
                    font-size: 13px;
                    display: flex;
                    align-items: center;
                  ">
                    <span style="
                      display: inline-block;
                      width: 6px;
                      height: 6px;
                      background: ${displayValue === 0 ? '#808080' : '#52c41a'};
                      border-radius: 50%;
                      margin-right: 6px;
                    "></span>
                    总舆情
                  </span>
                  <span style="
                    color: #ffffff;
                    font-weight: 600;
                    font-size: 14px;
                  ">${displayValue}${displayValue === 0 ? '' : ''}</span>
                </div>


              </div>

              <!-- 底部装饰线 -->
              <div style="
                position: absolute;
                bottom: 0;
                left: 0;
                right: 0;
                height: 2px;
                background: linear-gradient(90deg, transparent 0%, #00feff 50%, transparent 100%);
              "></div>
            </div>
          `;
          return tipHtml;
        },
      },
      geo: [
        {
          map: '广西',
          aspectScale: 1,
          zoom: 0.65,
          layoutCenter: ['50%', '50%'],
          layoutSize: '180%',
          show: true,
          roam: false,
          label: {
            emphasis: {
              show: false,
            },
          },
          itemStyle: {
            normal: {
              borderColor: '#c0f3fb',
              borderWidth: 1,
              shadowColor: '#8cd3ef',
              shadowOffsetY: 10,
              shadowBlur: 120,
              areaColor: 'transparent',
            },
          },
        },
        // 重影
        {
          type: 'map',
          map: '广西',
          zlevel: -1,
          aspectScale: 1,
          zoom: 0.65,
          layoutCenter: ['50%', '51%'],
          layoutSize: '180%',
          roam: false,
          silent: true,
          itemStyle: {
            normal: {
              borderWidth: 1,
              // borderColor:"rgba(17, 149, 216,0.6)",
              borderColor: 'rgba(58,149,253,0.8)',
              shadowColor: 'rgba(172, 122, 255,0.5)',
              shadowOffsetY: 5,
              shadowBlur: 15,
              areaColor: 'rgba(5,21,35,0.1)',
            },
          },
        },
        {
          type: 'map',
          map: '广西',
          zlevel: -2,
          aspectScale: 1,
          zoom: 0.65,
          layoutCenter: ['50%', '52%'],
          layoutSize: '180%',
          roam: false,
          silent: true,
          itemStyle: {
            normal: {
              borderWidth: 1,
              // borderColor: "rgba(57, 132, 188,0.4)",
              borderColor: 'rgba(58,149,253,0.6)',
              shadowColor: 'rgba(65, 214, 255,1)',
              shadowOffsetY: 5,
              shadowBlur: 15,
              areaColor: 'transpercent',
            },
          },
        },
        {
          type: 'map',
          map: '广西',
          zlevel: -3,
          aspectScale: 1,
          zoom: 0.65,
          layoutCenter: ['50%', '53%'],
          layoutSize: '180%',
          roam: false,
          silent: true,
          itemStyle: {
            normal: {
              borderWidth: 1,
              // borderColor: "rgba(11, 43, 97,0.8)",
              borderColor: 'rgba(58,149,253,0.4)',
              shadowColor: 'rgba(58,149,253,1)',
              shadowOffsetY: 15,
              shadowBlur: 10,
              areaColor: 'transpercent',
            },
          },
        },
        {
          type: 'map',
          map: '广西',
          zlevel: -4,
          aspectScale: 1,
          zoom: 0.65,
          layoutCenter: ['50%', '54%'],
          layoutSize: '180%',
          roam: false,
          silent: true,
          itemStyle: {
            normal: {
              borderWidth: 5,
              // borderColor: "rgba(11, 43, 97,0.8)",
              borderColor: 'rgba(5,9,57,0.8)',
              shadowColor: 'rgba(29, 111, 165,0.8)',
              shadowOffsetY: 15,
              shadowBlur: 10,
              areaColor: 'rgba(5,21,35,0.1)',
            },
          },
        },
      ],
      series: [
        {
          name: '广西市数据',
          type: 'map',
          map: '广西', // 自定义扩展图表类型
          aspectScale: 1,
          zoom: 0.65, // 缩放
          showLegendSymbol: true,
          label: {
            normal: {
              show: true,
              textStyle: {
                color: '#fff',
                fontSize: '120%',
              },
            },
            emphasis: {
              // show: false,
            },
          },
          itemStyle: {
            normal: {
              areaColor: {
                type: 'linear',
                x: 1200,
                y: 0,
                x2: 0,
                y2: 0,
                colorStops: [
                  {
                    offset: 0,
                    color: 'rgba(3,27,78,0.75)', // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: 'rgba(58,149,253,0.75)', // 50% 处的颜色
                  },
                ],
                global: true, // 缺省为 false
              },
              borderColor: '#fff',
              borderWidth: 0.2,
            },
            emphasis: {
              show: false,
              color: '#fff',
              areaColor: 'rgba(0,254,233,0.6)',
            },
          },
          layoutCenter: ['50%', '50%'],
          layoutSize: '180%',
          markPoint: {
            symbol: 'none',
          },
          data: mapData,
        },
        // 水波纹效果 - 只显示数值大于0的城市
        {
          name: '舆情水波纹',
          silent: false,
          type: 'effectScatter',
          coordinateSystem: 'geo',
          rippleEffect: {
            period: 4,
            brushType: 'stroke',
            scale: 8,
          },
          label: {
            normal: {
              show: false,
              position: 'right',
              offset: [5, 0],
              formatter: function(params: any) {
                return params.data.name + ' (' + params.data.originalValue + ')';
              },
              fontSize: 13,
              color: 'white',
            },
            emphasis: {
              show: true,
            },
          },
          symbol: 'circle',
          symbolSize: function(val: any, params: any) {
            // 根据数据值动态调整大小
            const originalValue = params.data.originalValue;
            return [
              Math.max(6, Math.min(originalValue / 10 + 6, 16)),
              Math.max(6, Math.min(originalValue / 10 + 6, 16)),
            ];
          },
          itemStyle: {
            normal: {
              borderWidth: 2,
            },
          },
          tooltip: {
            formatter: function(params: any) {
              return `${params.data.name}: ${params.data.originalValue}`;
            },
          },
          data: waveData,
        },
      ],
    };

    option && this.myChart.setOption(option);

    let index = 0; //播放所在下标
    let showTip = setInterval(() => {
      this.myChart.dispatchAction({
        type: 'showTip',
        seriesIndex: 0,
        dataIndex: index,
      });
      index++;
      if (index >= 14) {
        index = 0;
      }
    }, 2000);

    this.myChart.on('mouseover', (params: { dataIndex: any }) => {
      clearInterval(showTip);
      this.myChart.dispatchAction({
        type: 'showTip',
        seriesIndex: 0,
        dataIndex: params.dataIndex,
      });
    });

    this.myChart.on('mouseout', () => {
      showTip && clearInterval(showTip);
      showTip = setInterval(() => {
        this.myChart.dispatchAction({
          type: 'showTip',
          seriesIndex: 0,
          dataIndex: index,
        });
        index++;
        if (index >= 14) {
          index = 0;
        }
      }, 2000);
    });
  }

  mounted() {
    this.init();
  }
}
